/* Toast helper using sonner */
import { toast } from "sonner";

export const notify = {
  success: (msg, opts) => toast.success(msg, { duration: 3500, ...opts }),
  error: (msg, opts) => toast.error(msg, { duration: 4500, ...opts }),
  info: (msg, opts) => toast(msg, { duration: 3500, ...opts }),
};
